export { default } from './AwaitingVerificationShops'
